<template>
  <div class="mb48 orderSearch tms-style">
    <el-card class="mtf1">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" label-position="left">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.CustomerNumber')">
              <el-input v-model="searchForm.Customer_No" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.Ordernumber')">
              <el-input v-model="searchForm.Booking_No" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.Orderinterval')">
              <el-date-picker
                style="width:95%"
                v-model="searchForm.CreateInterval"
                type="daterange"
                range-separator="~"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
                class="custom-input"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item :label="$t('TankService.MasterHouseBillofLading')" label-width="110px">
              <el-input v-model="searchForm.MBL_HBL_NO" size="small" style="width:96%" class="custom-input" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.ContainerNo')">
              <el-input v-model="searchForm.Container_No" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.Portofdeparture')">
              <el-input v-model="searchForm.POL_Name" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.Portofdischarge')">
              <el-input v-model="searchForm.POD_Name" size="small" style="width:96%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.ProductName')" label-width="110px">
              <el-input v-model="searchForm.Goods_CN" size="small" style="width:96%" class="custom-input" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="custom-flex-center" style="margin-top: 20px">
          <el-button type="primary" size="small" class="buttonSize" icon="el-icon-search" :loading="fullscreenLoading" @click="query">{{ $t('TankService.Inquiry') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-refresh-right" :loading="fullscreenLoading" @click="empty">{{ $t('TankService.Reset') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-download" :loading="fullscreenLoading" @click="exportData">{{ $t('TankService.Export') }}</el-button>
          <!-- <el-button type="primary" size="small" class="buttonSize" icon="el-icon-plus" :loading="fullscreenLoading" @click="addMilestone" >{{ '订阅模板' }}</el-button> -->

        </div>
      </el-form>
    </el-card>
    <el-card class="mt10">
      <div class="custom-flex-space-between mb20">
        <div style=" font-size: 16px">{{ $t('TankService.DetailedView') }}</div>
        <el-tooltip class="showType" effect="dark" :open-delay="500" :content="showType ? $t('TankService.SwitchtoListMode'):$t('TankService.SwitchtoCardMode')" placement="bottom">
          <img v-if="showType" src="@/assets/fms/order_list_card.png" @click="showTypeChange">
          <img v-else src="@/assets/fms/order_list_table.png" @click="showTypeChange">
        </el-tooltip>
      </div>
      <el-collapse v-if="showType" v-model="activeNames" v-loading="loading" class="custom-el-collapse el-collapse">
        <el-collapse-item v-for="i in dataList" :key="i.Booking_No" :name="i.Booking_No">
          <div slot="title" class="w100">
            <div class="order-title custom-flex-space-between" @click="toggleCollapse(i)">
              <img src="@/assets/fms/订单.png" class="order-img">
              <div style="flex:1">
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:20%">
                    <span class="order-label">{{ $t('TankService.Ordernumber')+' ：' }}</span>
                    <span class="order-text-booking">{{ i.Booking_No }}</span>
                  </div>
                  <div class="inline-block " style="width:25%">
                    <span class="order-label">{{ $t('TankService.Ordertime')+' ：' }}</span>
                    <span class="order-text">{{ convertYMD(i.CreateDT) }}</span>
                  </div>
                  <div class="inline-block " style="width:30%">
                    <span class="order-label">{{ $t('TankService.Billofladingnumber')+' ：' }}</span>
                    <span class="order-text">{{ i.MBL_NO }}</span>
                  </div>
                </div>
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:20%">
                    <span class="order-label">{{ $t('TankService.Portofdeparture')+' ：' }}</span>
                    <span class="order-text">{{ i.POL+'/'+ i.POL_Name }}</span>
                  </div>
                  <div class="inline-block ml18" style="width:25%">
                    <span class="order-label">{{ $t('TankService.Portofdischarge')+' ：' }}</span>
                    <span class="order-text">{{ i.POD+'/'+ i.POD_Name }}</span>
                  </div>
                  <div class="inline-block ml18" style="width:30%">
                    <span class="order-label">{{ $t('TankService.TypeCount')+' ：' }}</span>
                    <span class="order-text">{{ i.TankType }}</span>
                  </div>
                </div>
              </div>
             <span class="collapsed" >{{ i.collapsed ? $t('TankService.PutItAway') : $t('TankService.DetailedView') }}</span>
          </div>
          </div>
          <div class="custom-flex-space-between">
            <div class="w100 order-title-wrap" >
              <el-row class="w100" style="display: flex;margin-left: 17px">
                <div style="width:31%">
                    <el-row class="details-text" >
                      <el-col class="details-label1">{{ $t('TankService.Grossweight')+'(KGS) ：' }}</el-col>
                      <el-col class="details-value1">{{ ext.roundFixed(i.GW,2) }}</el-col>
                    </el-row>
                    <el-row class="details-text">
                    <el-col class="details-label1">{{ $t('TankService.ProductName')+' ：' }}</el-col>
                    <el-col class="details-value1">{{ lang === 'zh'?i.Goods_CN:i.Goods_EN }}</el-col>
                  </el-row>
                </div>
                <div style="width:28%">
                  <el-row class="details-text">
                      <el-col class="details-label2">{{ $t('TankService.Volume')+'(CBM) ：' }}</el-col>
                      <el-col class="details-value2">{{ ext.roundFixed(i.CBM,2) }}</el-col>
                    </el-row>
                    <el-row class="details-text">
                    <el-col v-if="i.Delivery_AddressList !=='' && i.Delivery_AddressList !==null " class="details-label3">{{ $t('TankService.Deliveryplace')+' ：' }}</el-col>
                    <el-col class="details-value2">
                      <el-tooltip
                      :content="addressTooltip(i.Delivery_AddressList,'2')"
                      effect="dark"
                      :disabled="false"
                      placement="top-start"
                      :enterable="false"
                    >
                      <span> {{ addressTooltip(i.Delivery_AddressList,'1') }}</span>
                    </el-tooltip>
                    </el-col>
                  </el-row>
                </div>
                <div style="width:34%">
                  <el-row class="details-text">
                      <el-col class="details-label3">{{ $t('TankService.ContainerNo')+' ：' }}</el-col>
                      <el-col class="details-value3">
                      <el-tooltip
                      :content="containerNoTooltip(i.Container_No,'2')"
                      effect="dark"
                      :disabled="false"
                      placement="top-start"
                      :enterable="false"
                    >
                      <span> {{ containerNoTooltip(i.Container_No,'1') }}</span>
                    </el-tooltip>
                    </el-col>
                    </el-row>
                </div>
                <div style="margin-right: 10px;">
                  <el-button type="primary" class="custom-el-button" size="small" style="display: block; width: 100px" @click="AddMilestone(i)">
                    <span><img src="@/assets/gms/xinzeng.png" >
                    {{ i.IsTake===1 ? $t('TankService.Subscribed') : $t('TankService.Subscription') }}</span>
                  </el-button>
                </div>
                <div style="">
                  <el-button type="primary" class="custom-el-button" size="small" style="display: block; width: 100px" @click="downloadAttachment(i)">
                    <span><img src="@/assets/fms/下载.png" >
                    {{ $t('TankService.DownloadAttachment') }}</span>
                  </el-button>
                </div>
              </el-row>
              <el-row class="w100">
                  <OrderStep :statu-list="getMilestoneData(i)" />
              </el-row>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-else style="padding: 0px 20px 20px 20px">
        <el-table
          ref="orderTable"
          v-loading="loading"
          stripe
          :data="dataList"
        >
          <el-table-column type="index" width="50" :index="getIndex" :label="$t('TankService.SerialNumber')" />
          <el-table-column prop="Customer_No" width="150" :label="$t('TankService.CustomerNumber')" />
          <el-table-column prop="Booking_No" width="150" :label="$t('TankService.Ordernumber')" />
          <el-table-column prop="MBL_NO" width="170" :label="$t('TankService.Billofladingnumber')" />
          <el-table-column
            prop="AUDIT_TYPE"
            width="200"
            :label="$t('TankService.OrderStatus')"
            :formatter="(row)=>{
              return orderNode(row)
            }"
          />
          <el-table-column
            :label="$t('TankService.Ordertime')"
            prop="CreateDT"
            width="115"
            :formatter="(row)=>{
              return convertYMD(row.CreateDT)
            }"
          />
          <el-table-column prop="Pkgs_Num" width="110" :label="$t('TankService.TypeCount')"
           :formatter="(row)=>{
              return row.TankType
            }" />
          <el-table-column prop="CBM" width="120" :label="$t('TankService.volume')+'(CBM)'" />
          <el-table-column prop="POL" width="190" :label="$t('TankService.Portofdeparture')"
          :formatter="(row)=>{
              return row.POL+'/'+row.POL_Name
            }" />
          <el-table-column prop="POD" width="190" :label="$t('TankService.Portofdischarge')"
          :formatter="(row)=>{
              return row.POD+'/'+row.POD_Name
            }"/>
          <el-table-column prop="Delivery_AddressList" width="300" :label="$t('TankService.Deliveryplace')">
            <template slot-scope="scope">
              <el-tooltip
                :content="addressTooltip(scope.row.Delivery_AddressList,'2')"
                effect="dark"
                :disabled="false"
                placement="top-start"
                :enterable="false"
              >
                <span>{{ addressTooltip(scope.row.Delivery_AddressList,'1') }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="165" :label="$t('TankService.Operation')" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="AddMilestone(scope.row)">{{ scope.row.IsTake===1 ? $t('TankService.Subscribed') : $t('TankService.Subscription') }}</el-button>
              <el-button type="text" size="small" style="marginLeft:12px" @click="downloadAttachment(scope.row)" >{{ $t('TankService.DownloadAttachment') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div class="footPage">
      <el-pagination
        class="custom-el-pagination floatR"
        background
        layout="sizes, prev, pager, next"
        :current-page.sync="curPageIndex"
        :page-sizes="[10,20, 50, 100]"
        :page-size="pageSize"
        :total="listTotalCount"
        @size-change="pageSizeChangeHandle"
        @current-change="curPageChangeHandle"
      />
      <div class="disclaimer" :style="{left: lang == 'zh' ? '210px' : '210px' }">
        <div>
        <p>&nbsp;<img src="@/assets/wms/disclaimerIcon.svg" style="display:inline" />&nbsp;{{ $t('TankService.Content1') }}</p>
        </div>
      </div>
    </div>
    <TankfileDialog
      v-if="tankfileDialogShow"
      :visible.sync="tankfileDialogShow"
      :title="curTitle"
      :cur-row="curRow"
    />
    <MilestoneListDialog
      v-if="milestoneListDialogShow"
      :visible.sync="milestoneListDialogShow"
      :customerCode="CustomerCode"
      :customerName="CustomerName"
      jobtype="TE"
      jobTypeId="PM18050007"
      tableName="FMS_SeaJob"
    />
    <MilestoneDialog
      :visible.sync="dialogVisible"
      :milestoneInfo="milestoneInfo"
      :customerCode="CustomerCode"
      :customerName="CustomerName"
      @submit="onteOrderFormSubmit"
      />
  </div>
</template>
<script>
import GMS_TANK from '@/assets/json/gmsTankDetail.json'
import { getTEImportPageList, getMailSubscription } from '@/api/gmsTank.js'
import OrderStep from '@/components/fms/orderStep/index.vue'
import { convertYMD, conversionyyyyMMdd, parseTime, dateAdds } from '@/utils/index'
import { ISStr, EnumValueLocal } from '@/utils/isClass'
import TankfileDialog from '@/components/gms/tankfileDialog.vue'
import MilestoneListDialog from '@/components/gms/TE/milestoneList'
import MilestoneDialog from '@/components/gms/TE/milestoneDialog'
import { exportToExcel } from '@/vendor/Export2Excel.js'
import { tableRowClassName } from '@/utils/fms/tableClass'
import i18n from '@/i18n/i18n'
const searchForm = {
  Customer_Code: '',
  Booking_No: '',
  Customer_No: '',
  MBL_HBL_NO: '',
  CreateInterval: [
    parseTime(
      dateAdds(new Date(), -30, 'd'),
      '{y}-{m}-{d}'
    ),
    parseTime(new Date(), '{y}-{m}-{d}')
  ],
  POL_Name: '',
  POD_Name: ''
}
export default {
  components: { OrderStep, TankfileDialog, MilestoneListDialog, MilestoneDialog },
  props: {
    customerCode: {
      type: String,
      default: ''
    },
    customerName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'zh',
      milestoneInfo: {
        JobType: 'TE',
        Job_TypeId: 'PM18050007',
        TableName: 'FMS_SeaJob',
      },
      IsTake_S: [
        { name: i18n.t('TankService.All'), id: '' },
        { name: i18n.t('TankService.YES'), id: 1 },
        { name: i18n.t('TankService.NO'), id: 0 }
      ],
      EnumValueLocal,
      ISStr,
      convertYMD,
      conversionyyyyMMdd,
      tableRowClassName,
      loading: false,
      showType: true,
      fullscreenLoading: false,
      activeNames: [],
      dataList: [],
      dialogVisible: false,
      searchForm: JSON.parse(JSON.stringify(searchForm)),
      searchSendCarForm: JSON.parse(JSON.stringify(searchForm)), // 搜索条件
      listTotalCount: 0,
      curPageIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      tankfileDialogShow: false,
      milestoneListDialogShow: false,
      curTitle: i18n.t('TankService.DownloadAttachment'),
      milestoneTitle: i18n.t('TankService.SubscriptionInformation'),
      CustomerCode: this.customerCode,
      CustomerName: this.customerName,
      // 日期时间范围在一个月以内
      pickerOptions: {
        disabledDate: (time) => {
          if (this.disabledDateRange && this.disabledDateRange.length > 0) {
            return (
              time.getTime() < this.disabledDateRange[0].getTime() ||
              time.getTime() > this.disabledDateRange[1].getTime()
            )
          } else {
            return false
          }
        },
        onPick: (picks) => {
          if (picks.maxDate) {
            this.disabledDateRange = []
          } else {
            this.disabledDateRange = [
              dateAdds(picks.minDate, -30, 'd'),
              dateAdds(picks.minDate, 30, 'd')
            ]
          }
        }
      }
    }
  },
  computed: {},
  mounted() {
    this.lang = this.$ls.get('lang');
    this.init()
  },
  methods: {
    onteOrderFormSubmit() {
      this.getList()
    },
    init() {
      this.getList()
    },
    getIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    showTypeChange() {
      this.showType = !this.showType
    },
    /**  查询 */
    query() {
      this.fullscreenLoading = true
      var _this = this
      this.pageIndex = 1
      this.searchSendCarForm = JSON.parse(JSON.stringify(_this.searchForm))
      this.getList()
    },
    /**  清空 */
    empty() {
      this.searchForm = JSON.parse(JSON.stringify(searchForm))
      this.searchSendCarForm = JSON.parse(JSON.stringify(searchForm))
    },
    /**  列表查询 */
    getList() {
      this.loading = true
      const pagination = {}
      pagination.pageIndex = this.pageIndex
      pagination.pagesize = this.pageSize
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      data.lang = this.lang
      getTEImportPageList(data).then((res) => {
        var data = JSON.parse(res.data)
        this.listTotalCount = data?.total
        const result = data?.rows ?? []
        this.dataList = result
        this.activeNames = []
        this.curPageIndex = this.pageIndex
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        this.loading = false
        this.fullscreenLoading = false
        console.log(err)
      })
    },
    pageSizeChangeHandle(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getList()
    },
    curPageChangeHandle(pageIndex) {
      this.pageIndex = pageIndex
      this.getList()
    },
    /**  节点 */
    getMilestoneData(item) {
      const data = []
      try {
        if (!ISStr((item.ReceivingOrdersTime))) {
          data.push({ Name: i18n.t('TankService.OrderReceived'), EventDT: this.milestoneTime(item.ReceivingOrdersTime), OpenImg: require('@/assets/fms/接单.png'), ShutImg: require('@/assets/fms/接单—灰.png') })
        } else {
          data.push({ Name: i18n.t('TankService.OrderReceived'), EventDT: this.milestoneTime(item.CreateDT), OpenImg: require('@/assets/fms/接单.png'), ShutImg: require('@/assets/fms/接单—灰.png') })
        }
        if (!ISStr((item.ETDTime)))
        {
            data.push({ Name: 'ETD', EventDT: this.milestoneTime(item.ETDTime), OpenImg: require('@/assets/fms/ETA.png'), ShutImg: require('@/assets/fms/ETA—灰.png') })
        }
        if (!ISStr((item.ATDTime)))
        {
             data.push({ Name: 'ATD', EventDT: this.milestoneTime(item.ATDTime), OpenImg: require('@/assets/fms/签收.png'), ShutImg: require('@/assets/fms/签收—灰.png') })
        }
        data.push({ Name: 'ETA', EventDT: this.milestoneTime(item.ETATime), OpenImg: require('@/assets/fms/ETA.png'), ShutImg: require('@/assets/fms/ETA—灰.png') })
        data.push({ Name: 'ATA', EventDT: this.milestoneTime(item.ATATime), OpenImg: require('@/assets/fms/签收.png'), ShutImg: require('@/assets/fms/签收—灰.png') })
        data.push({ Name: i18n.t('TankService.DeliveryDT'), EventDT: this.milestoneTime(item.BusinessCompletionTime), OpenImg: require('@/assets/fms/开航.png'), ShutImg: require('@/assets/fms/开航—灰.png') })
        data.push({ Name: i18n.t('TankService.Returnbox'), EventDT: this.milestoneTime(item.CustomsClearanceTime), OpenImg: require('@/assets/fms/签收.png'), ShutImg: require('@/assets/fms/签收—灰.png') })
        return data
      } catch (error) {
        return data
      }
    },
    /** 送货地址提示 */
    addressTooltip(address, type) {
      if (ISStr(address)) { return '' }
      var addressList = address.split(',')
      if (type === '1') {
        return addressList[0]
      } else if (type === '2') {
        return i18n.t('TankService.Deliveryplace') + ' ：' + addressList
      }
    },
    /** 送货地址提示 */
    containerNoTooltip(containerNo, type) {
      if (ISStr(containerNo)) { return '' }
      var containerNoList = containerNo.split(',')
      if (type === '1') {
        if (containerNoList.length > 1)
        {
          return containerNoList[0] + ',' + containerNoList[1] + '...'
        }
        else{
          return containerNoList[0]
        }
      } else if (type === '2') {
        return i18n.t('TankService.ContainerNo') + ' ：' + containerNoList
      }
    },
    /** 附件下载 */
    downloadAttachment(row) {
      this.curTitle = i18n.t('TankService.DownloadAttachment') + ' ' + row.Booking_No
      this.curRow = row
      this.tankfileDialogShow = true
    },
    /** 添加订阅服务 */
    async AddMilestone(row) {
      const params = { BookingNo: row.Booking_No, SourceType: '', JobType: 'TE' }
      var res = await getMailSubscription(params)
      if (res && res.isSuccess) {
        var data = res.data
        this.milestoneInfo = {
          ...data,
          Booking_No: row.Booking_No,
          Type: '1',
          CustomerCode: this.customerCode,
          CustomerName: this.customerName
        }
      }
      this.dialogVisible = true
    },
    /** milestone时间大于当前时间的不显示 */
    milestoneTime(time) {
      const contime = conversionyyyyMMdd(time)
      if (ISStr(contime)) return null
      const getDate = conversionyyyyMMdd(new Date())
      if (contime <= getDate) {
        return contime.toString('yyyy-MM-dd HH:mm:ss')
      } else {
        return null
      }
    },
    /** 导出 */
    exportData() {
      this.loading = true
      this.fullscreenLoading = true
      const pagination = {}
      // 导出全部查询数据
      pagination.pageIndex = 1
      pagination.pagesize = this.listTotalCount
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      data.lang = this.lang
      getTEImportPageList(data).then((res) => {
        var data = JSON.parse(res.data)
        this.listTotalCount = data?.total
        const result = data?.rows ?? []
        // 转换数据为工作表对象
        var dataList = result.map(x => {
          var data = {
            Customer_No: x.Customer_No,
            Booking_No: x.Booking_No,
            MBL_NO: x.MBL_NO,
            AUDIT_TYPE: this.orderNode(x),
            CreateDT: convertYMD(x.CreateDT),
            GW: x.GW,
            CBM: x.CBM,
            Pkgs_Num: x.TankType,
            POL_Name: x.POL + '/' + x.POL_Name,
            POD_Name: x.POD + '/' + x.POD_Name,
            Delivery_AddressList: x.Delivery_AddressList,
            ReceivingOrdersTime: !ISStr(this.milestoneTime(x.ReceivingOrdersTime)) ? this.milestoneTime(x.ReceivingOrdersTime) : convertYMD(x.CreateDT),
            ETDTime: this.milestoneTime(x.ETDTime),
            ATDTime: this.milestoneTime(x.ATDTime),
            ETATime: this.milestoneTime(x.ETATime),
            ATATime: this.milestoneTime(x.ATATime),
          }
          // 有报关服务显示报关节点
          data.CustomsClearanceTime = this.milestoneTime(x.CustomsClearanceTime)
          data.BusinessCompletionTime = this.milestoneTime(x.BusinessCompletionTime)
          return data
        })
        var column = [
          { lable: i18n.t('TankService.CustomerNumber'), width: 20 }, // Customer_No
          { lable: i18n.t('TankService.Ordernumber'), width: 20 }, // Booking_No
          { lable: i18n.t('TankService.Billofladingnumber'), width: 20 }, // MBL_NO
          { lable: i18n.t('TankService.OrderStatus'), width: 15 }, // AUDIT_TYPE
          { lable: i18n.t('TankService.Ordertime'), width: 15 }, // CreateDT
          { lable: i18n.t('TankService.Grossweight') + '(KGS)', width: 15 }, // GW
          { lable: i18n.t('TankService.Volume') + ' (CBM)', width: 15 }, // CBM
          { lable: i18n.t('TankService.TypeCount'), width: 15 }, // Pkgs_Num
          { lable: i18n.t('TankService.Portofdeparture'), width: 20 }, // POL_Name
          { lable: i18n.t('TankService.Portofdischarge'), width: 20 }, // POD_Name
          { lable: i18n.t('TankService.Deliveryplace'), width: 50 }, // Delivery_AddressList
          { lable: i18n.t('TankService.OrderReceived'), width: 20 }, // ReceivingOrdersTime
          { lable: 'ETD', width: 20 }, // ETDTime
          { lable: 'ATD', width: 20 }, // ATDTime
          { lable: 'ETA', width: 20 }, // ETATime
          { lable: 'ATA', width: 20 }, // ATATime
          { lable: i18n.t('TankService.Returnbox'), width: 20 }, // CustomsClearanceTime
          { lable: i18n.t('TankService.DeliveryDT'), width: 20 } // BusinessCompletionTime
        ]
        exportToExcel({ column, dataList, filename: i18n.t('TankService.Tank') + '_' + i18n.t('TankService.Content2') + this.convertYYYMMDD() })
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        this.loading = false
        this.fullscreenLoading = false
        console.log(err)
      })

    },
    convertYYYMMDD() {
      try {
        const d = new Date()
        const year = d.getFullYear()
        const month = this.plusZero(d.getMonth() + 1)
        const day = this.plusZero(d.getDate())
        return year + month + day
      } catch (err) {
        console.log(err.message)
        return time
      }
    },
    plusZero(val) {
      if (val >= 0 && val <= 9) {
        return '0' + val
      } else {
        return val
      }
    },
    /** 根据订单节点显示订单状态 */
    orderNode(row) {
      // milestone时间大于当前时间的不显示，订单状态也需要不显示
      const getDate = convertYMD(new Date())
      if (!ISStr(row.BusinessCompletionTime) && convertYMD(row.BusinessCompletionTime) <= getDate) {
        return i18n.t('TankService.Delivery') + '(' + convertYMD(row.BusinessCompletionTime) + ')'
      } else if (!ISStr(row.CustomsClearanceTime) && convertYMD(row.CustomsClearanceTime) <= getDate) {
        return i18n.t('TankService.Returnbox') + '(' + convertYMD(row.CustomsClearanceTime) + ')'
      } else if (!ISStr(row.ATATime) && convertYMD(row.ATATime) <= getDate) {
        return 'ATA' + '(' + convertYMD(row.ATATime) + ')'
      } else if (!ISStr(row.ETATime) && convertYMD(row.ETATime) <= getDate) {
        return 'ETA' + '(' + convertYMD(row.ETATime) + ')'
      } else if (!ISStr(row.ATDTime) && convertYMD(row.ATDTime) <= getDate) {
        return 'ATD' + '(' + convertYMD(row.ATDTime) + ')'
      } else if (!ISStr(row.ETDTime) && convertYMD(row.ETDTime) <= getDate) {
        return 'ETD' + '(' + convertYMD(row.ETDTime) + ')'
      } else if (!ISStr(row.CreateDT) && convertYMD(row.CreateDT) <= getDate) {
        return i18n.t('TankService.OrderReceived') + '(' + convertYMD(row.CreateDT) + ')'
      } else {
        return ''
      }
    },
    /**  点击时切换展开和收缩状态 */
    toggleCollapse(row) {
      row.collapsed = !row.collapsed;
    },
    /**  新增订阅 */
    addMilestone() {
      this.milestoneListDialogShow = true
    }
  }
}
</script>
<style scoped>
@import "~@/styles/fms/tableClass.scss";
.orderSearch >>> .el-date-editor .el-range-separator{
  width: initial;
  display: block !important;
}
.orderSearch >>> .el-form-item{
  margin-bottom: initial;
}
.orderSearch >>> .el-table .el-table__cell{
  padding: initial;
}

/* 公共样式提取至内部 开始*/
.custom-input >>> .el-input__inner {
  border: 1px solid #60aabc;
  max-width: 300px;
  background: #fff;
}
.custom-input >>> .el-range-input {
  background: #fff;
  max-width: 500px;
}

.custom-input.el-input__inner>>> {
  background: #f6f6f8;
}

.custom-input.el-date-editor {
  background: #f6f6f8;
}
.custom-input.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-range-input {
    background: white !important;
}

.custom-el-collapse {
  border: 0;
}
.custom-el-collapse .el-collapse-item {
    border-radius: 8px;
    margin-bottom: 13px;
    box-shadow: none;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__header {
  margin: 0;
  font-size: 16px;
  font-weight: normal !important;
  height: auto;
  color: #111827;
  background-color: #fff !important;
  border: 0 !important;
  border-radius: 8px !important;
  line-height: initial;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__wrap {
  border-top: 1px solid #dcdee2;
  border-radius: 0 0 8px 8px;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px !important;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  border-top: #fff;
}
.mtf1 >>> .el-card__body{
  padding: 20px 20px 20px 39px !important;
}
.mt10 {
  margin-top: 16px;
}
.mb20 {
  margin-bottom: 0px;
  padding: 10px 20px 10px 20px;
  border-radius: 4px 4px 0 0;
  border: 1px solid #ebeef5;
}
.ml18 {
  margin-left: 17px;
}
.mb48{
  margin-bottom: 48px;
}
.w100 {
  width: 100%;
}
.floatR {
  float: right;
}
.el-collapse .divTitle {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}
.inline-block {
  display: inline-block;
}
.showType {
  width: 20px;
  height: 20px;
}
.footPage {
  z-index: 3;
  background-color: #fff;
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 36px;
  padding: 8px 16px;
}
/* 样式改版 */
.text-content {
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号代替溢出部分 */
  white-space: nowrap; /* 不换行 */
}
.search{
  border: 1px solid #67B0C4 !important;
  border-color: #67B0C4 !important;
  color: #67B0C4;
}
.order-img{
  width: 24px !important;
  height: 30px !important;
  display: inline-block;
}
.mt10 >>> .el-card__body{
  padding: 0px !important;
}
.order-title{
  padding: 36px 45.5px 33px 32px;
  width: 100% !important;
}
.custom-el-collapse{
  background-color: aliceblue;
}
.order-label{
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 24px;
}
.order-text{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.order-text-booking{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #67B0C4;
  border-radius: 6px;
  line-height: 22px;
}
.order-text-jobtype{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 22px;
  background: #E8F3F6;
  color: #084156;
  border-radius: 6px;
  padding: 2px 10px 2px 10px;
}
.details-label1{
  width: 110px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value1{
  width: 200px;
}
.details-label2{
  width: 130px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value2{
  width: 220px;
}
.details-label3{
  width: 90px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value3{
  width: 240px;
}
.details-text{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
  width: 350px;
}
.details-title{
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 24px;
  margin-bottom: 13px;
}
.custom-el-button span{
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.custom-el-button img{
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.custom-el-collapse >>> .el-collapse-item__arrow {
  display: none !important;
}
.collapsed{
  float: right;
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #67b0c4;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-title-wrap{
  padding: 25px 28px 17px 27px !important;
}
.orderSearch >>> .el-card{
  border: 0px !important;
}
.buttonSize{
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}
.disclaimer{
  position: fixed;
  left: 210px;
  bottom: 0;
  right: 0;
  background: #F0F6FC;
  color:#8CA2BD;
  opacity: 0.85;
  font-size:12px;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
</style>
